"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.haversineDistanceKm = void 0;
const EARTH_RADIUS_KM = 6371;
const toRadians = (degrees) => (degrees * Math.PI) / 180;
const haversineDistanceKm = (from, to) => {
    const deltaLat = toRadians(to.lat - from.lat);
    const deltaLon = toRadians(to.lon - from.lon);
    const a = Math.sin(deltaLat / 2) ** 2 +
        Math.cos(toRadians(from.lat)) * Math.cos(toRadians(to.lat)) * Math.sin(deltaLon / 2) ** 2;
    return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(a));
};
exports.haversineDistanceKm = haversineDistanceKm;
